// Added by Sejune Oh on 2019-02-01
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react'
import Typography, { TypographyProps } from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Properties of typography component
 */
interface TypographyFCProps extends TypographyProps { }

const StyledTypography = withStyles({
    root: {
        color: '#fff',
    },
})(Typography)

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Typography component
 */
const CoreTypography = (props: TypographyFCProps) => {
    const { variant, ...other } = props
    return <StyledTypography {...other} variant={variant} />
}

export default CoreTypography
